import axios from 'axios';
import jwtDecode from 'jwt-decode';
import {
  app, firebase, db, auth,
} from '@/vendors/firebase/firebase';
import authTransformer from './authTransformer';
import User from '../../../entities/User';

const ls = require('local-storage');

export default {
  getUserToken() {
    return ls.get('userToken');
  },
  isAuthenticated() {
    return !!ls.get('userToken');
  },
  async isAuthenticatedFirebase() {
    const isAuthenticatedFirebase = await firebase.auth().currentUser;
    return isAuthenticatedFirebase !== null;
  },
  async logout() {
    return Promise.resolve(true);
  },
  async loginWithCustomToken(token) {
    await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION);
    const { user } = await auth.signInWithCustomToken(token);
    return { user };
  },
  async loginWithCredentials(email, password) {
    const { user } = await firebase
      .auth()
      .signInWithEmailAndPassword(email, password);
    return user;
  },
  async getCurrentCustomTokenUserInfo() {
    try {
      const { claims } = await auth.currentUser.getIdTokenResult();
      return claims.userInfo;
    } catch {
      return null;
    }
  },
  async getAllUsers() {
    const res = [];
    const snapshot = await app.firestore()
      .collection('users')
      .get();
    snapshot.forEach((doc) => {
      res.push(authTransformer.transformOne(doc.data()));
    });
    console.log(authTransformer.transformList(res));
    return authTransformer.transformList(res);
  },
  async listenUserState(cb) {
    // eslint-disable-next-line
    return new Promise((resolve) => {
      return auth.onAuthStateChanged((user) => {
        if (cb) { cb(user); }
        resolve(user);
      });
    });
  },
  async getUserByUid(uid) {
    const docRef = db.collection('users').doc(uid);

    let userDoc = await docRef.get().then((doc) => {
      if (doc.exists) {
        return doc.data();
      }
      return null;
    }).catch((error) => {
      console.log(error);
      return null;
    });
    if (userDoc === null) {
      return null;
    }
    const displayName = `${userDoc.firstname} ${userDoc.lastname}`;
    userDoc = { displayName, ...userDoc };
    return userDoc;
  },
  async getUsersFromShop() {
    const url = process.env.VUE_APP_LIST_USERS_ENDPOINT;
    const shopToken = ls.get('shopToken');
    const { shopId } = jwtDecode(shopToken);

    const { data } = await axios.get(url, {
      headers: {
        'shop-token': shopId,
      },
    });
    return data.map((user) => new User(user));
  },
  async sendMagicLink(email) {
    console.log(email);
    const res = await axios.get(process.env.VUE_APP_REQUEST_SHOP_MAGIC_LINK_ENDPOINT, {
      params: {
        callbackURL: process.env.VUE_APP_MAGIC_LINK_CALLBACK_ENDPOINT,
        email,
      },
    });
    console.log(res);
    return res;
  },
  async checkUserGuide() {
    const { uid } = ls.get('userToken');
    // const shopTokenDecode = jwtDecode(shopToken);
    console.log('uid');
    console.log(uid);

    const userGuide = await db.collection('UserGuide')
      // .where('dateBeg', '<=', today) <-- Pas besoin dateBeg car import a dateBeg
      .where('uid', '==', uid)
      .where('guide', '==', 'firstGuide')
      .get()
      .then((querySnapshot) => {
        let value = null;
        if (!querySnapshot.empty) {
          const data = querySnapshot.docs[0].data();
          value = data;
        }
        return value;
      })
      .catch((error) => {
        console.log('Error getting documents: ', error);
      });

    if (userGuide !== null) {
      return false;
    }

    return true;
  },
  async setUserGuide() {
    const { uid } = ls.get('userToken');
    // const shopTokenDecode = jwtDecode(shopToken);
    console.log('uid');
    console.log(uid);
    db.collection('UserGuide').add({
      uid,
      guide: 'firstGuide',
    });
  },
};
